// @flow

export {default as setupTypeParsers} from './setupTypeParsers';
